import { render, staticRenderFns } from "./EditVoteItem.vue?vue&type=template&id=260eb337&scoped=true&"
import script from "./EditVoteItem.vue?vue&type=script&lang=js&"
export * from "./EditVoteItem.vue?vue&type=script&lang=js&"
import style0 from "./EditVoteItem.vue?vue&type=style&index=0&id=260eb337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260eb337",
  null
  
)

export default component.exports